/* Casa M Spice Co® — "The Lineup" homepage quick-view modal (DRM / Bloom).
   Opens a per-card <dialog> on card click; qty stepper; Add to Cart POSTs
   /cart/add.js with _added_from:'home' (+ selling_plan when Subscribe is chosen
   via casam-buy-box.js) then refreshes + opens the existing cart drawer. Mirrors
   the casam-cart.js contract (cart:build + cart:open) without touching it. */
(function () {
  'use strict';

  function dialogFor(el) {
    var card = el.closest('[data-qv-target]');
    if (!card) return null;
    return document.getElementById(card.getAttribute('data-qv-target'));
  }

  // ── open: click the card's PHOTO or NAME opens the modal (Bloom data-qv
  //    pattern). The Quick Add button + everything else on the card behave
  //    normally, so the cards stay 100% shoppable from the home page. ──
  document.addEventListener('click', function (e) {
    if (e.target.closest('.cmqv')) return;                 // clicks inside an open modal
    // honor modifier / middle-click "open in new tab" on the photo/name links
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || (e.button && e.button !== 0)) return;
    var trigger = e.target.closest('.cmbs-card[data-qv-target] .cmbs-photo a, .cmbs-card[data-qv-target] .cmbs-name a');
    if (!trigger) return;                                  // not the photo/name → let it be (Quick Add, etc.)
    var card = trigger.closest('.cmbs-card[data-qv-target]');
    var dlg = document.getElementById(card.getAttribute('data-qv-target'));
    if (!dlg || typeof dlg.showModal !== 'function') return; // no dialog support → link falls through to PDP
    e.preventDefault();
    dlg.showModal();
  });

  // ── close: × button, or backdrop (click on the dialog itself, outside the card) ──
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cmqv-close]')) {
      var d = e.target.closest('.cmqv'); if (d) d.close(); return;
    }
    if (e.target.classList && e.target.classList.contains('cmqv')) {
      e.target.close(); // backdrop (dialog element is the event target only on the backdrop)
    }
  });

  // ── qty stepper ──
  function readQty(form) {
    var i = form.querySelector('[data-cmqv-qty]');
    var n = parseInt(i && i.value, 10);
    return (!n || n < 1) ? 1 : Math.min(n, 99);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cmqv-inc],[data-cmqv-dec]');
    if (!btn) return;
    var form = btn.closest('form'); if (!form) return;
    var input = form.querySelector('[data-cmqv-qty]'); if (!input) return;
    var n = readQty(form);
    n = btn.hasAttribute('data-cmqv-inc') ? Math.min(n + 1, 99) : Math.max(n - 1, 1);
    input.value = n;
  });
  document.addEventListener('input', function (e) {
    var i = e.target.closest('[data-cmqv-qty]'); if (!i) return;
    i.value = (i.value || '').replace(/[^0-9]/g, '');
  });
  // clamp the DISPLAYED value to 1–99 when the field loses focus (readQty already
  // clamps what's sent; this stops a stale "0"/""/"999" lingering in the box)
  document.addEventListener('change', function (e) {
    var i = e.target.closest('[data-cmqv-qty]'); if (!i) return;
    var f = i.closest('form'); if (f) i.value = readQty(f);
  });

  // ── add to cart (mirrors casam-cart.js addWithSource, + qty + selling_plan) ──
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cmqv-add]');
    if (!btn || btn.disabled) return;
    var form = btn.closest('form'); if (!form) return;
    var sel = form.querySelector('select[name="id"]');
    var vid = (sel && sel.value) || btn.getAttribute('data-vid');
    if (!vid) return;
    var planInput = form.querySelector('[data-cc-selling-plan]');
    var plan = planInput && planInput.value ? planInput.value : null;
    var qty = readQty(form);

    var label = btn.querySelector('[data-add-to-cart-text]') || btn;
    var orig = label.textContent;
    btn.disabled = true; label.textContent = 'Adding…';

    var body = { id: vid, quantity: qty, properties: { _added_from: 'home' } };
    if (plan) body.selling_plan = Number(plan) || plan;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        // DRM-470: arm the empty-cart settle window (casam-cart.js listens for
        // ajaxProduct:added → markAdd) BEFORE cart:build reads /cart.js, so a
        // transient stale-empty read can't wipe the upsell on a first add.
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        document.dispatchEvent(new CustomEvent('cart:build'));
        var dlg = btn.closest('.cmqv'); if (dlg) dlg.close();
        setTimeout(function () { document.dispatchEvent(new CustomEvent('cart:open')); }, 250);
      })
      .catch(function () {
        // fall back to the PDP so the shopper is never stuck
        var handle = btn.getAttribute('data-handle');
        if (handle) window.location.href = '/products/' + handle;
      })
      .then(function () { btn.disabled = false; label.textContent = orig; });
  });
})();
